import { TextField } from "@mui/material";

const WhiteTextField = ({ sx = {}, InputLabelProps = {}, ...props }) => {
  return (
    <TextField
      {...props}
      InputLabelProps={{
        ...InputLabelProps,
        sx: {
          top: "50%",
          transform: "translateY(-50%)",
          left: "16px",
          transition: "all 200ms ease",
          "&.Mui-focused, &.MuiInputLabel-shrink": {
            top: -9,
            transform: "translateY(0) scale(0.75)",
          },
          ...(InputLabelProps.sx || {}),
        },
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          height: "40px",
          backgroundColor: "#FFFFFF",
          borderRadius: "5px",
          paddingRight: "5px",
          overflow: "hidden",

          "& input": {
            color: "#333",
            borderRadius: "inherit",
          },

          "&:hover fieldset": {
            borderColor: "#E6E4E9",
          },

          "&.Mui-focused fieldset": {
            borderColor: "#CDCDCF",
          },

          "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus, & input:-webkit-autofill:active":
            {
              WebkitBoxShadow: "0 0 0 1000px #FFFFFF inset !important",
              WebkitTextFillColor: "#333 !important",
              caretColor: "#333 !important",
              borderRadius: "inherit",
            },
        },
        ...sx,
      }}
      variant="outlined"
    />
  );
};

export default WhiteTextField;
